import template from './thankYouConfirmation.html';
import './thankYouConfirmation.scss';

export const ThankYouConfirmation = angular
    .module('checkout.components.thankYouConfirmation', [])
    .component('thankYouConfirmation', {
        template,
        bindings: {
            order: '<'
        },
        controller: class ThankYouConfirmationCtrl {
            constructor($window) {
                this.$window = $window;
            }

            print() {
                this.$window.print();
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/thankYou/thankYouConfirmation/thankYouConfirmation.js